// USAGE:
// var httpLib = require('./http-library.js');
//
// var requestParams = {
//     host: HOST,
//     port:  PORT,
//     method: "GET",
//     path: 'PATH',
//     headers: {
//        'Authorization': 'Bearer '+config.internal_handshake_base64
//     },
// };
//
// var postBody = {boop: "beep"};
//
// httpLib.request(request_params, function(response) {
//     //do stuff with response
// }, postBody);

// EXAMPLE RESPONSE:
// Sucess:
// {
//    statusCode: 200,
//    listings: [{},{}]
// }
// Error:
// {
//    statusCode: 400,
//    error: 'invalid password'
// }

var http = require('http');
var _ = require('lodash');

var checkHeaders = function (headers, postBody) {
  var headersIfBody = {
    'Content-Type': 'application/json',
    'Content-Length': postBody ? postBody.length : 0
  };

  var headersDefault = {
    Accept: 'application/json',
    'Cache-Control': 'no-cache, must-revalidate',
    Pragma: 'no-cache'
  };

  return _.assign((postBody ? headersIfBody : headersDefault), headers);
};

exports.request = function (providedRequestParams, callback, optionalBody) {
  const includeTimestamp = providedRequestParams.includeTimestamp == undefined ? true : providedRequestParams.includeTimestamp;
  var requestParams = providedRequestParams;

  if (!requestParams.method) {
    requestParams.method = 'GET';
  }

  if (-1 === ['GET', 'PUT', 'POST', 'DELETE'].indexOf(requestParams.method)) {
    throw new Error('requestParams.method value was '
     + requestParams.method + ' , but must be one of \'GET\', \'PUT\', \'POST\', \'DELETE\'');
  }

  var postBody; var unsanitizedBody;

  if (optionalBody) {
    try {
      unsanitizedBody = JSON.stringify(optionalBody);
      postBody = unsanitizedBody.replace(/(<([^>]+)>)/ig, '');
    } catch (e) {
      throw new Error('optionalBody was provided, but errored when stringified:', e);
    }
  }

  var requestHeaders = checkHeaders(requestParams.headers, postBody);
  var newReqParams = requestParams;
  var path = requestParams.path;
  newReqParams.headers = requestHeaders;
  newReqParams.timeout = 10000;
  if (-1 === path.indexOf('?') && includeTimestamp) {
    newReqParams.path += '?timestamp=' + Date.now();
  }

  var request = http.request(newReqParams, function (response) {
    var responseString = '';

    response.on('data', function (d) {
      responseString += d;
    });

    response.on('end', function () {
      var responseObject;
      try {
        responseObject = JSON.parse(responseString);
        responseObject.statusCode = response.statusCode;
        const path = newReqParams.path;
        if (399 < response.statusCode && 'object' === typeof analyticsIntegrations) {
          if (-1 === ['PUT', 'POST'].indexOf(newReqParams.method)) {
            analyticsIntegrations.formFail(path, responseString);
          } else if ('GET' === newReqParams.method) {
            analyticsIntegrations.requestFail(path, responseString);
          }
        }
      } catch (e) {
        responseObject = { error: 'Invalid JSON', responseData: responseString };
      }
      return callback(responseObject);
    });
  });

  request.on('error', function (e) {
    return callback({ error: e.message });
  });

  request.on('timeout', function () {
    request.abort();
    const path = newReqParams.path;
    const method = newReqParams.method;
    const loggerObj = {
      path: path,
      method: method,
      timeout: newReqParams.timeout
    };

    // eslint-disable-next-line no-console
    console.warn('API TIMEOUT', loggerObj);
  });


  if (postBody) {
    request.write(postBody);
  }

  request.end();
};
